



export interface ITextProps {
    text: string;
    fontFamily: string;
    fontSize: string;
    fontAlignment: "center" | "left" | "right" | "end" | "justify";
    fontWeight: number;
    color: string;
    visible: boolean;
}

export interface IInfoLabel extends ITextProps {
    backgroundColor: string;
    visible: boolean;
}
export interface IImageProps {
    url: string;
    mode: 'contain' | 'cover';
}

export enum ISiteObjectType {
    Undef = 0,
    Image = 1,
    Audio = 2,
    Video = 3,
    Html = 4,
    Rubaway = 5,
    LastValue = 6,
}

export interface IAudioSiteObjectViewModel extends ISiteObjectViewModel {
    foregroundImage: IImageProps;
    foregroundImageBackgroundColor: string;
    audioDescription: ITextProps;
    audioDescriptionBackgroundColor: string;
    controlsColor: string;
    headphonesMissingViewEnabled: boolean;
    headphonesMissingVisible: boolean;
    speakerIconVisible: boolean;
    spinnerVisible: boolean;
    spinnerColor: string;
    audioUrl: string;
}

export interface IVideoSiteObjectViewModel extends ISiteObjectViewModel {
    videoUrl: string;
    controlsColor: string;
}

export interface IHTMLSiteObjectViewModel extends ISiteObjectViewModel {
    htmlUrl: string;
}

export interface IRubawaySiteObjectViewModel extends ISiteObjectViewModel {
    rubawayImageUrl: string;
    infoLabel?: ITextProps;
    infoBackgroundColor: string;
}

export interface IRubawayViewModel extends ISiteObjectViewModel {
    foregroundImageUrl: string;
    toolTipTitle: ITextProps;
    toolTipBackgroundColor: string;
}

export interface ISiteObjectViewModel {
    title: ITextProps;
    backgroundColor: string;
    backgroundImage: IImageProps;
    backButton: {
        backgroundColor: string;
        strokeColor: string;
        strokeSize: string;
        arrowColor: string;
        visible: boolean;
    }
    data?: any;
    onLoad?: (update: (model: ISiteObjectViewModel) => void) => void;
    onRemove?: (model: ISiteObjectViewModel) => ISiteObjectViewModel;
    onComplete?: (model: ISiteObjectViewModel) => void;
}

export interface ISiteObjectMainProps<T extends ISiteObjectViewModel> {
    model: T;
}

export interface ISiteObjectIndexProps {
    model: ISiteObjectViewModel;
    type: ISiteObjectType;
}
